import {
  Currency,
  type CurrencyConstructor,
} from '@webapp/core/entities/external/Currency'

export interface RequestMileageConfigurationConstructor {
  rate: number
  currency: CurrencyConstructor
  isLocked: boolean
}

export class RequestMileageConfiguration {
  readonly rate: number
  readonly currency: Currency
  readonly isLocked: boolean

  constructor(data: RequestMileageConfigurationConstructor) {
    this.rate = data.rate
    this.currency = new Currency(data.currency)
    this.isLocked = data.isLocked
  }
}
